import React, { useState } from "react";
import { toast } from "react-toastify";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import Title from "../../components/Title";
import { useNavigate } from "react-router-dom";
import schema from "./schema_fb_graph.json";
import { RoutePages } from "../../ultils";

const EXECUTOR_API_URL = process.env.REACT_APP_EXECUTOR_API_URL;
schema.servers[0].url = process.env.REACT_APP_EXECUTOR_API_URL;

const FBGraphDocs = () => {
    const navigate = useNavigate();
    const [accessToken, setAccessToken] = useState("");
    const [customPath, setCustomPath] = useState("");
    const [endpoint, setEndpoint] = useState(null);
    const [response, setResponse] = useState(null);
    const [latency, setLatency] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleInputChange = (e) => setCustomPath(e.target.value);
    const handleTokenChange = (e) => setAccessToken(e.target.value);

    const callApi = async () => {
        if (!customPath || !accessToken) {
            setError("Please input path and access_token!");
            return;
        }
        if (!customPath.startsWith("/")) {
            setError("Path must start with '/'");
            return;
        }
        setLoading(true);
        setError(null);
        setResponse(null);
        try {
            const url = EXECUTOR_API_URL + "/graph" + customPath + (customPath.includes("?") ? "&" : "?") + "access_token=" + accessToken;
            setEndpoint(url);
            const start = performance.now();
            const res = await fetch(url);
            setLatency(performance.now() - start);
            const data = await res.json();
            setResponse(data);
        } catch (err) {
            setError("Error: " + err.message);
        }
        setLoading(false);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") callApi();
    };

    return (
        <div className="px-2 py-2 pb-5 max-w-full bg-gradient-to-br from-blue-50 via-white to-green-50 min-h-screen">
            <Title page={RoutePages.DOCS.FB_GRAPH} title="Docs FB-Graph" />
            {/* Brief description */}
            <div className="flex flex-col mb-4 bg-white p-4 sm:p-6 rounded-2xl shadow-lg border max-w-full mx-auto animate-fade-in">
                <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-2">
                    <h2 className="w-full sm:w-2/3 text-2xl sm:text-3xl font-extrabold text-center sm:text-left text-blue-700 tracking-wide">
                        Facebook Graph API
                    </h2>
                    <div className="w-full sm:w-1/3 flex justify-center sm:justify-end gap-3">
                        <button onClick={() => navigate("/pricing/fb_graph")} className="w-full sm:w-auto px-4 py-2 text-white text-base font-semibold rounded-lg bg-gradient-to-r from-green-400 to-green-600 hover:from-green-500 hover:to-green-700 shadow transition-all duration-200">
                            Free Trial
                        </button>
                        <button onClick={() => navigate("/pricing/fb_graph")} className="w-full sm:w-auto px-4 py-2 text-white text-base font-semibold rounded-lg bg-gradient-to-r from-blue-400 to-blue-600 hover:from-blue-500 hover:to-blue-700 shadow transition-all duration-200">
                            Buy
                        </button>
                        <a
                            href="https://developers.facebook.com/docs/graph-api/reference"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-full sm:w-auto px-4 py-2 text-blue-700 text-base font-semibold rounded-lg border border-blue-400 bg-white hover:bg-blue-50 hover:text-blue-900 shadow transition-all duration-200 text-center"
                        >
                            Full Official Docs
                        </a>
                    </div>
                </div>
                <div className="flex flex-col mb-2">
                    <p className="text-gray-700 text-base text-begin max-w-3xl">
                        <b>Get fully detailed</b> videos, posts, comments, reactions, pages, places, ...<br/>
                        99% the same as the official Facebook Graph API but <b>without Meta granted permissions.</b><br/>
                        Just replace <b>"https://graph.facebook.com"</b> with <b>"{EXECUTOR_API_URL}/graph"</b> and enjoy the API right away!
                    </p>
                </div>
            </div>
            {/* Customizable API Explorer */}
            <div className="flex flex-col gap-2 mb-4 bg-white p-4 rounded-2xl shadow-lg border max-w-full mx-auto">
                <div className="flex flex-col sm:flex-row justify-between items-center">
                    <h2 className="w-full text-2xl font-bold text-center sm:text-left text-blue-700 tracking-wide">
                        Customizable Graph API Explorer
                    </h2>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 items-center">
                    <label className="font-semibold min-w-[110px] text-gray-700">Access Token:</label>
                    <input
                        className="flex-1 border-2 border-cyan-300 rounded-md px-3 py-1 w-full focus:outline-none focus:ring-2 focus:ring-cyan-400 transition"
                        type="text"
                        placeholder="Input access_token..."
                        value={accessToken}
                        onChange={handleTokenChange}
                    />
                </div>
                <div className="flex flex-col sm:flex-row gap-3 items-center">
                    <span className="font-semibold text-gray-700 break-all">{EXECUTOR_API_URL + "/graph"}</span>
                    <input
                        className="flex-1 border-2 border-cyan-300 rounded-md px-3 py-1 w-full focus:outline-none focus:ring-2 focus:ring-cyan-400 transition"
                        type="text"
                        placeholder="Input path, e.g. /v19.0/me"
                        value={customPath}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                    />
                    <button
                        className="w-full sm:w-auto bg-blue-600 text-white px-4 py-1 rounded-lg font-semibold hover:bg-blue-700 transition-all duration-200"
                        onClick={callApi}
                        disabled={loading}
                    >
                        {loading ? "Loading..." : "Call"}
                    </button>
                </div>
                {endpoint &&
                    <div className="flex flex-col sm:flex-row gap-2 items-center break-all">
                        <label className="rounded-md border bg-green-300 px-2 py-1 font-bold mr-0 sm:mr-3">GET</label>
                        <label
                            className="rounded-md cursor-pointer border bg-gray-200 px-2 py-1 hover:bg-gray-500 hover:text-white transition"
                            onClick={() => { navigator.clipboard.writeText(endpoint); toast.success("Copied!", { duration: 100 }) }}
                        >
                            {endpoint}
                        </label>
                    </div>
                }
                <div className="">
                    <div className="flex flex-col sm:flex-row gap-4 mb-2 text-xs text-gray-500">
                        {response && (
                            <>
                                <span>
                                    Latency: <span className="font-semibold text-blue-700">{latency.toFixed(0)}ms</span>
                                </span>
                                <span>
                                    Data length: <span className="font-semibold text-blue-700">{JSON.stringify(response).length.toLocaleString()}</span> bytes
                                </span>
                            </>
                        )}
                    </div>
                    <div className="bg-gray-100 rounded-lg p-3 max-h-72 overflow-auto text-sm border border-gray-300 shadow-inner">
                        {error && <div className="text-red-600">{error}</div>}
                        {response && (
                            <pre className="whitespace-pre-wrap break-all">{JSON.stringify(response, null, 2)}</pre>
                        )}
                        {!response && !error && <span className="text-gray-400">No response data</span>}
                    </div>
                </div>
            </div>
            {/* Swagger UI */}
            <div className="bg-white p-2 sm:p-4 rounded-2xl shadow-lg border overflow-x-auto max-w-full mx-auto animate-fade-in">
                <SwaggerUI spec={schema} />
            </div>
        </div>
    );
};
export default FBGraphDocs;
